import { Box, Step, StepButton, Stepper, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import {
    EntityStep,
    updateActiveFirstLevelStep,
    updateEntityInstancePath,
} from '../../../redux/slices/entityInstanceSlice'
import theme from '../../../theme/theme'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

// this "ParentEntitySteps" only showen when we are going to access nested level entities
const FirstLevelSteps = (): ReactElement => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()

    const path = useAppSelector((state) => state.entityInstance.path)

    const firstLevelSteps = useAppSelector(
        (state) => state.entityInstance.firstLevelSteps,
    )
    const activeFirstLevelStep = useAppSelector(
        (state) => state.entityInstance.activeFirstLevelStep,
    )

    const handleFirstLevelStep = (index: number) => () => {
        dispatch(updateActiveFirstLevelStep(index))

        if (!path[0]) return

        const updatedFirst = {
            ...path[0],
            activeStep: index,
        }
        dispatch(
            updateEntityInstancePath({
                path: [updatedFirst],
                isFirst: false,
                hasStartStep: false,
            }),
        )
    }

    return (
        <Box>
            {firstLevelSteps?.length > 1 && path?.length > 1 ? (
                <Box
                    sx={{
                        marginTop: '20px',
                        marginBottom: '30px',
                        padding: '0px 10px',
                    }}
                >
                    <Stepper nonLinear activeStep={activeFirstLevelStep}>
                        {firstLevelSteps?.map(
                            (label: EntityStep, index: any) => (
                                <Step
                                    key={index}
                                    sx={{
                                        minWidth: '100px',
                                    }}
                                >
                                    <StepButton
                                        color="inherit"
                                        onClick={handleFirstLevelStep(index)}
                                        className="first-entity-steps-tabs"
                                        icon={<></>}
                                        id={`first-level-step-${label.step}`}
                                    >
                                        <Box display="flex" alignItems="center">
                                            <Box
                                                sx={{
                                                    // width: '25px',
                                                    // height: '25px',
                                                    padding: '3px 4px',
                                                    minWidth: '18px',
                                                    color: '#fff',
                                                    fontSize: '12px',
                                                    background:
                                                        label.stepNo - 1 ===
                                                        activeFirstLevelStep
                                                            ? theme.palette
                                                                  .primary.main
                                                            : '#00000061',
                                                    borderRadius: '50%',
                                                    display: 'flex !important',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    marginRight: '10px',
                                                }}
                                            >
                                                {label.step}
                                            </Box>
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                alignItems="flex-start"
                                                marginLeft="5px"
                                                minWidth="50px"
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: '12px',
                                                        marginBottom: '5px',
                                                        marginTop: '-3px',
                                                    }}
                                                >
                                                    {t('step')} {label.step}
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        textWrap: 'nowrap',
                                                    }}
                                                >
                                                    {t(label.relationName)}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </StepButton>
                                </Step>
                            ),
                        )}
                    </Stepper>
                </Box>
            ) : null}
        </Box>
    )
}

export default FirstLevelSteps
